<template>
  <b-container fluid>
    <b-row>

      <b-col cols="3"></b-col>
      <b-col cols="6"> <SettingsComponent v-if="userDetails" :details="userDetails" :update-status="updateStatus" @update="onUpdate"  ></SettingsComponent>  </b-col>
      <b-col cols="3"></b-col>
    </b-row>
  </b-container>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import UserService from "../../services/UserService";
import SettingsComponent from "./SettingsComponent";

export default {
  name: 'SettingsPage',

  data() {
    return {
      userDetails: null,
      updateStatus: null
    }
  },

  components: {
    SettingsComponent
  },

  computed: {
    ...mapState(['activeSurvey', 'absoluteDrillPath', 'userIdentity']),
    ...mapGetters(['realmName', 'studyName', 'authToken', 'pageByName', 'completePath']),

  },

  methods: {
    loadUserDetails(userId) {
      UserService.getUserDetails(this.authToken, this.realmName, userId).then((response) => {
        this.userDetails = response.data
      })
    },

    onUpdate(dto) {
      UserService.updateUserSettings(this.authToken, this.realmName, dto).then((response) => {
        this.updateStatus = response.data.result
      })

    }

  },

  watch: {
    $route: {
      handler() {
        this.loadUserDetails(this.userIdentity.userId)
      },
      immediate: true
    },

  }

}
</script>